const UserActions = {
  INITIALIZE: 'INITIALIZE',
  LOGIN: 'LOGIN',
  LOAD_PERMISSIONS: 'LOAD_PERMISSIONS',
  LOAD_PERMISSION_PATHS: 'LOAD_PERMISSION_PATHS',
  CHECK_PERMISSION: 'CHECK_PERMISSION',
  LOGOUT: 'LOGOUT',
};

const InitialtUser = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  userInfo: { id: 0, name: 'Invitado', email: '' },
  logged: false,
  permissions: null,
  permissionPaths: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
      userInfo: user,
      permissions: user?.permissions,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: true,
      user,
      userInfo: user,
      permissions: user?.permissions,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    userInfo: InitialtUser.userInfo,
  }),
  LOAD_PERMISSIONS: (state, action) => ({
    ...state,
    permissions: action.payload,
  }),
  LOAD_PERMISSION_PATHS: (state, action) => ({
    ...state,
    permissionPaths: action.payload,
  }),
};

const UserReducer = (state, action) => {
  return handlers[action.type] ? handlers[action.type](state, action) : state;
};

export { InitialtUser, UserActions };
export default UserReducer;
